import { modifier } from '@lokalise/louis';

import styled, { css } from '@app/styled';
import { mediaQuery } from '@app/theme';

export const OnboardingContainer = styled.div<{ $largeAccent?: boolean }>`
    display: grid;
    grid-template-columns: auto 480px;
    min-height: 100vh;

    ${modifier(
        '$largeAccent',
        css`
            grid-template-columns: auto 45vw;
        `,
    )}

    ${mediaQuery.max('md')} {
        grid-template-columns: 100%;
        padding: 0 5vw;
        overflow: auto;
    }
`;

export const MainContentContainer = styled.div`
    position: relative;
    padding-top: 120px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
`;

export const MainContentOutlet = styled.div`
    display: grid;
    align-items: center;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    justify-content: center;
`;

export const OutletContainer = styled.div`
    display: grid;
    justify-content: center;
`;

export const AccentContainer = styled.div`
    background-color: #fde047;
    box-shadow: inset 5px 1px 5px rgba(0, 0, 0, 0.05);
    position: relative;

    ${mediaQuery.max('md')} {
        display: none;
    }
`;

export const AccentInner = styled.div`
    width: 100%;
    height: 100%;
`;
